import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router';
import InitLoader from '../../components/InitLoader/InitLoader';

function AuthGuard({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  useEffect(() => {
    // If authentication is still being checked, do nothing
    if (Object.is(isAuthenticated, null)) {
      return;
    }

    // Get any error descriptions from URL
    const params = new URLSearchParams(window.location.hash.substring(1));
    const errorDescription = params.get('error_description')
      ? params.get('error_description').split('|')[1]
      : undefined;

    // If not authenticated, redirect to login
    if (!isAuthenticated) {
      navigate('/', {
        replace: true,
        state: { errorDescription },
      });
    }
  }, [isAuthenticated, navigate]);

  // Show intialising loader while checking authentication
  if (Object.is(isAuthenticated, null)) {
    return <InitLoader />;
  }

  // User is authenticated, render children
  if (isAuthenticated) {
    return children;
  }

  // This return should not be reached due to the redirect in useEffect
  return null;
}

AuthGuard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthGuard;
